import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NewThesesComponent } from './new-theses/new-theses.component';
import { ThesesAuthorsComponent } from './theses-authors/theses-authors.component';
import { ThesesDataComponent } from './theses-data/theses-data.component';
import { ThesesDoneComponent } from './theses-done/theses-done.component';
import { ThesesEndRegMsgComponent } from './theses-end-reg-msg/theses-end-reg-msg.component';

const routes: Routes = [
  { path: ':alias', component: NewThesesComponent, children: [
    { path: '', redirectTo: 'authors', pathMatch: 'full' },
    { path: 'authors', component: ThesesAuthorsComponent },
    { path: 'theses-data', component: ThesesDataComponent },
    { path: 'done', component: ThesesDoneComponent },
  ]},
  { path: ':alias/end-message', component: ThesesEndRegMsgComponent }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ThesesRoutingModule { }
